require("!!/Users/admin/dev/pixo_dev/node_modules/script-loader/addScript.js")(require("!!/Users/admin/dev/pixo_dev/node_modules/raw-loader/index.js!/Users/admin/dev/pixo_dev/pixo/assets/flexibility/flexibility.js")+"\n\n// SCRIPT-LOADER FOOTER\n//# sourceURL=script:///Users/admin/dev/pixo_dev/pixo/assets/flexibility/flexibility.js")


/*****************
 ** WEBPACK FOOTER
 ** ./~/script-loader!./pixo/assets/flexibility/flexibility.js
 ** module id = 13
 ** module chunks = 0
 **/